module.exports = __webpack_public_path__ + "static/michelle-48a664413a0dca2a49ae9ff9dac739b0.jpg";